// NOTE: Please do not add new constants to this file.
// Add them @/constants/[name] instead
import type { FeedbackType } from '@/components/Feedback/types'
import { COLLEGE_PARTNER_DETAILS } from '@/components/Partners/constants'

export const ONBOARDING_REFERRAL_NAMES = [
  'A friend',
  'My school',
  'My parent',
  'Khan Academy',
  'Key Club',
  'YouTube',
  'Facebook',
  'Reddit',
  'Instagram',
  'TikTok',
  'Google',
  'Bing',
  ...Object.values(COLLEGE_PARTNER_DETAILS).map(partner => partner.name),
  'SAT Daily',
  'Art of Problem Solving',
  'Other',
]

export const SESSION_DURATION_OPTIONS = [20, 30, 40, 45, 50, 60, 70, 75, 80, 90, 120, 180]
export const SESSION_DURATION_DEFAULT = 60

// Zoom Education account max meeting capacity is 300.
// 300 is also the max page_size for Zoom's participant report APIs.
export const ZOOM_MAX_PARTICIPANTS = 300
// UI limits size options for users, but admins can use any positive integer
// up to ZOOM_MAX_PARTICIPANTS, which is all we validate.
export const SESSION_SIZE_OPTIONS_EXCLUDING_1_ON_1 = [
  5,
  10,
  12,
  15,
  20,
  30,
  40,
  50,
  75,
  100,
  150,
  200,
  ZOOM_MAX_PARTICIPANTS,
]
export const SESSION_SIZE_OPTIONS = [1].concat(SESSION_SIZE_OPTIONS_EXCLUDING_1_ON_1)

export const SESSION_SIZE_DEFAULT = 10

export const NEW_TUTOR_SESSION_THRESHOLD = 3

export const LEARNER_FEEDBACK_FEATURED_LIMIT_PER_TYPE = 3
export const FEATURED_FEEDBACK_LIMIT_PER_TYPE: Record<FeedbackType, number> = {
  'old-audit': 100,
  audit: 100,
  session: 100,
  post: 100,
  self: 100,
  'learner-self': LEARNER_FEEDBACK_FEATURED_LIMIT_PER_TYPE,
  'learner-peer': LEARNER_FEEDBACK_FEATURED_LIMIT_PER_TYPE,
}

export const SESSION_FEEDBACK_NUM_MINUTES_EARLY = 2
export const SESSION_FEEDBACK_MAX_DAYS_BACK = 14

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const
